<template>
  <section>
    <div class="container p-0">
      <div class="row justify-content-center">
        <div class="col m-5">
          <h2 id="offersMessage" class="text-center">
            {{ noOffersMessage }}
          </h2>
          <p id="offersContext" class="text-center">{{ noOffersContext }}</p>
        </div>
      </div>
      <img
        :src="`${useAsset('img/error_image.png')}`"
        alt="error image"
        class="mx-auto d-block"
      />
    </div>
    <div class="text-center p-2">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <button
            class="pj-green-btn pj-wide btn mb-4 btn-wide start-again"
            @click.prevent="startAgain"
          >
            {{
              isSelfOnboarding
                ? t("SHARED.SELF_ONBOARDING.START_AGAIN")
                : t("SHARED.START_AGAIN")
            }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import cancelCartState from "@/apps/merchant3/hooks/cancelCartState";
import { cancelCart } from "@/apps/merchant3/services/carts.service";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import useAsset from "@/apps/merchant3/shared-helpers/useAsset";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";
import { getAPIErrorMessage } from "@/apps/merchant3/shared-helpers/APIErrorMessages";
import {
  isRentalFlow,
  isSubscriptionFlow,
} from "@/apps/merchant3/helpers/checkoutFlows";

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const cartTag = computed(() => {
  return store.state.carts.cartTag || null;
});

const props = defineProps({
  message: {
    default: "",
    type: String,
  },
  errorCode: {
    default: 0,
    type: Number,
  },
});

const noOffersContext = computed(() => {
  if ([10520, 10521].includes(props.errorCode)) {
    return getAPIErrorMessage({ errorCode: props.errorCode }, t, "");
  }

  return "";
});

const noOffersMessage = computed(() => {
  const appendSelfOnboardingPrefixIfExist = isSelfOnboarding.value
    ? "SELF_ONBOARDING."
    : "";
  const prefix = isRentalFlow.value
    ? "RENTAL_"
    : isSubscriptionFlow.value
      ? "SUBSCRIPTION_"
      : appendSelfOnboardingPrefixIfExist;

  const messageKey = props.message.includes("finance")
    ? `SHARED.${prefix}CUSTOMER_HAS_ACTIVE_FINANCE_ORDER`
    : `SHARED.${appendSelfOnboardingPrefixIfExist}SELL_PRICING_NOT_APPROVED_FOR_OFFERS`;

  return t(messageKey);
});

const startAgain = async () => {
  await cancelCart(cartTag.value, "Offers", "Customer not qualified");
  await cancelCartState();
  router.go(0);
};

const isSelfOnboarding = computed(() => {
  return store.state.carts?.productVersion == ProductVersion.M3_SELF_ONBOARDING;
});
</script>
